import { NavLink, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export default function NavBar() {
  const { t } = useTranslation();
  const { pathname } = useLocation();

  const Item = ({ to, label, icon }: { to: string; label: string; icon: string }) => {
    const active = pathname === to;
    return (
      <NavLink to={to} aria-label={label} className={`nav-icon ${active ? 'active' : ''}`}>
        <span className="nav-emoji" aria-hidden="true">{icon}</span>
        <span className="nav-label">{label}</span>
      </NavLink>
    );
  };

  return (
    <header className="nav">
      <nav className="nav-icons">
        <Item to="/"               label={t('nav.home')}     icon="🏠" />
        <Item to="/guide"          label={t('nav.guide')}    icon="📖" />
        <Item to="/players"        label={t('nav.players')}  icon="👨‍👩‍👧‍👦" />
        <Item to="/events"         label={t('nav.events')}   icon="📅" />
        <Item to="/halfyear"       label={t('nav.halfyear')} icon="🏆" />
        <Item to="/masters"        label={t('nav.masters')}  icon="🎓" />
      </nav>
    </header>
  );
}
